<template>
  <el-dropdown trigger="click" style="margin-left: 10px">
    <el-button size="small">
      导出
      <i class="el-icon-arrow-down"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native.stop="selectExport"
        >选定</el-dropdown-item
      >
      <el-dropdown-item @click.native.stop="allExport">全部</el-dropdown-item>
      <el-dropdown-item @click.native.stop="searchResultsExport"
        >搜索结果</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { postData } from "@/api/index";
export default {
  props: {
    E_ids: Array, //选中id
    E_dataLength: Number, //数据长度
    E_condition: Object, //搜索导出条件
    E_methodname: String, //调用方法名称
    E_searchArr: Array, //搜索条件是否填写
  },
  data() {
    return {
      objString: "",
      service_cname: localStorage.getItem("service_cname"),
      exporturl: this.hostName + "/excel.ExcelController/excelPortAction",
    };
  },
  methods: {
    objToString(obj) {
      let str = "";
      if (obj instanceof Object) {
        for (let i in obj) {
          if (obj[i]) {
            str += i + "=" + obj[i] + "&";
          }
        }
      } else {
        return "请传入一个对象";
      }
      return str.substring(0, str.length - 1);
    },
    changeString(obj) {
      this.objString =
        this.objToString(obj) + "&token=" + sessionStorage.getItem("token");
    },
    searchFlag(obj) {
      for (let i of this.E_searchArr) {
        if (obj[i]) return true;
      }
      return false;
    },
    selectExport() {
      if (this.E_ids.length) {
        let obj = {
          ...this.E_condition,
          page: 1,
          E_ids: this.E_ids.toString(),
        };
        this.changeString(obj);
        postData(this.exporturl, {
          param: this.objString,
          name: this.E_methodname,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("正在导出中！");
            location.href = res.data;
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请至少选择一条要导出的数据!",
        });
      }
    },
    allExport() {
      if (this.E_dataLength) {
        this.E_condition.pagesize = 10000;
        this.E_condition.page = 1;
        this.changeString(this.E_condition);
        postData(this.exporturl, {
          param: this.objString,
          name: this.E_methodname,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("正在导出中！");
            location.href = res.data;
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "导出数据不能为空!",
        });
      }
    },
    searchResultsExport() {
      if (this.searchFlag(this.E_condition)) {
        if (this.E_dataLength) {
          this.E_condition.pagesize = 10000;
          this.E_condition.page = 1;
          this.changeString(this.E_condition);
          postData(this.exporturl, {
            param: this.objString,
            name: this.E_methodname,
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success("正在导出中！");
              location.href = res.data;
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "导出数据不能为空!",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先搜索数据/数据不能为空!",
        });
      }
    },
  },
};
</script>

<style></style>
